import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e8508418"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "EntradaDeBusca" }
const _hoisted_2 = { class: "EntradaDeBusca__Componente p-input-icon-left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "EntradaDeBusca__IconeEsquerda pi pi-search" }, null, -1))

import InputText from "primevue/inputtext"
import { Nullable } from "primevue/ts-helpers"
import { computed } from "vue"
import { useI18n } from "vue-i18n"

interface Props {
  modelValue: Nullable<string>;
  dataTestid?: string;
  desabilitado?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MEntradaDeBusca',
  props: {
    modelValue: null,
    dataTestid: null,
    desabilitado: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: "update:modelValue", modelValue: Nullable<string>): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: Nullable<string>;
  dataTestid?: string;
  desabilitado?: boolean;
}

const { t } = useI18n()





const emitirModel = computed({
  get(): Nullable<string> {
    return props.modelValue
  },
  set(value: Nullable<string>) {
    emits("update:modelValue", value)
  },
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _hoisted_3,
      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(InputText)), {
        modelValue: _unref(emitirModel),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(emitirModel) ? (emitirModel).value = $event : null)),
        "aria-label": "Entrada para busca",
        class: "EntradaDeBusca__Entrada",
        "data-testid": __props.dataTestid,
        disabled: __props.desabilitado,
        placeholder: _unref(t)('pesquisarFiltros')
      }, null, 8, ["modelValue", "data-testid", "disabled", "placeholder"]))
    ])
  ]))
}
}

})